import { ISendInvitesDto } from './send-invites-dto.interface';

export interface IUpdateInviteDto extends Omit<ISendInvitesDto, 'email'> {
    id: string;
    email?: string;
}
